// extracted by mini-css-extract-plugin
export default {"colorBlackSqueeze":"#F2F7FA","colorViolet":"#080837","colorShuttleGrey":"#5C6770","latestBookings":"whIff1lu6ezHZ0cKkd71","title":"OQYyFTmz_iFar0g5RGqn"};